export interface ICityRegionMapping {
  city: string;
  region: string;
}

export interface GooglePlace {
  formatted_address?: string;
  address_components: Array<{
    long_name: string;
    short_name: string;
    types: string[];
  }>;
}

export enum NewFormSource {
  Dashboard = "dashboard",
  Application = "application",
}
